<template>
    <section class="pre-footer__container">
        <section v-for="section in sections"
                 :key="section.title"
                 class="pre-footer__container__section">
            <span class="pre-footer__container__section__title">
                {{ section.title }}
                <span @click="expand_menu(section.title)">+</span>
            </span>
            <transition name="slide-fade">
                <ul class="pre-footer__container__section__list-content"
                    v-if="show == section.title || isDesktop">
                    <li v-for="url in section.urls"
                        :key="url.url"
                        class="pre-footer__container__section__list-content__item">
                        <a :href="url.url" rel="dofollow"
                           class="pre-footer__container__section__list-item__link" target="_blank">{{ url.name }}</a>
                    </li>
                </ul>
            </transition>
        </section>
    </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
    setup() {

        const show = ref('');
        const isDesktop = ref(window.innerWidth >= 768);

        function updateScreenSize() {
            isDesktop.value = window.innerWidth >= 768;
        }

        function expand_menu(url) {
            if (url === show.value) {
                show.value = '';
            } else {
                show.value = url;
            }
        }

        onMounted(() => {
            window.addEventListener('resize', updateScreenSize)
        })

        onUnmounted(() => {
            window.removeEventListener('resize', updateScreenSize)
        })

        const sections = [
            {
                'title': 'PRÉSTAMO CON GARANTÍA MÉXICO',
                'urls': [
                    {
                        'url': "https://ibancar.mx/prestamos-garantia-auto-cdmx",
                        'name': "Préstamo con garantía CDMX",
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-garantia-auto-puebla",
                        'name': "Préstamo con garantía Puebla"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-garantia-auto-queretaro",
                        'name': "Préstamo con garantía Querétaro"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-garantia-auto-morelos",
                        'name': "Préstamo con garantía Morelos"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-garantia-auto-edomex",
                        'name': "Préstamo con garantía EDOMEX"
                    },
                ]
            },
            {
                'title': 'EMPEÑOS DE AUTO',
                urls: [
                    {
                        'url': "https://ibancar.mx/como-empenar-los-papeles-de-tu-auto-en-mexico",
                        'name': "Cómo empeñar los papeles de tu auto"
                    },
                    {
                        'url': "https://ibancar.mx/guia-completa-empenar-carro-en-mexico",
                        'name': "Guía completa para empeñar tu carro"
                    },
                    {
                        'url': "https://ibancar.mx/empeno-de-autos-en-ibancar",
                        'name': "Empeño de autos: rápido, seguro y confiable"
                    },
                    {
                        'url': "https://ibancar.mx/empena-tu-auto-y-continua-usandolo",
                        'name': "Empeño de autos en México: rápido y confiable"
                    },
                    {
                        'url': "https://ibancar.mx/empena-tu-auto-y-continua-usandolo",
                        'name': "Empeña tu auto y continúa usandolo"
                    },
                    {
                        'url': "https://ibancar.mx/empeno-facil",
                        'name': "Empeño fácil: funcionamiento, ventajas y proceso"
                    },
                    {
                        'url': "https://ibancar.mx/prestamo-garantia-auto",
                        'name': "Empeño de autos: rápido, seguro y confiable"
                    }
                ]
            },
            {
                'title': 'PRÉSTAMOS SOBRE AUTO',
                urls: [
                    {
                        'url': "https://ibancar.mx/prestamo-con-garantia-de-auto-sin-dejarlo",
                        'name': "Préstamos con garantia de coche sin dejarlo"
                    },
                    {
                        'url': "https://ibancar.mx/prestamo-garantia-automotriz",
                        'name': "Préstamos con garantia automotriz"
                    },
                    {
                        'url': "https://ibancar.mx/prestamo-sobre-vehiculo",
                        'name': "Préstamo sobre vehículo"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-sobre-auto-en-ibancar",
                        'name': "Préstamo sobre auto"
                    },
                    {
                        'url': "https://ibancar.mx/consigue-tu-credito-con-garantia-prendaria",
                        'name': "Consigue un crédito con garantía prendaria"
                    },
                    {
                        'url': "https://ibancar.mx/consigue-dinero-por-tu-carro-usado",
                        'name': "Consigue dinero por tu carro usado en México"
                    },
                    {
                        'url': "https://ibancar.mx/obten-tu-prestamo-por-automovil-con-ibancar",
                        'name': "Obtén tu préstamo por tu automóvil"
                    },
                    {
                        'url': "https://ibancar.mx/prestamo-factura-auto",
                        'name': "Obten préstamos con la factura de tu auto"
                    }
                ]
            },
            {
                'title': 'PRÉSTAMO RÁPIDO',
                urls: [
                    {
                        'url': "https://ibancar.mx/prestamos-confiables-y-rapidos",
                        'name': "Préstamos confiables"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-personales-urgentes",
                        'name': "Préstamo personal urgente"
                    },
                    {
                        'url': "https://ibancar.mx/prestamo-rapido",
                        'name': "Préstamo rápido"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-en-linea-por-tu-carro",
                        'name': "Préstamos en línea por tu carro: rápidos y seguros"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-en-linea-al-instante",
                        'name': "Préstamos en línea al instante con mi auto"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-personales-urgentes",
                        'name': "Préstamos personales urgentes"
                    },
                    {
                        'url': "https://ibancar.mx/prestamos-de-dinero-rapido",
                        'name': "Préstamos de dinero rápido"
                    }
                ]
            }
        ]

        return { sections, show, expand_menu, isDesktop }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';

.pre-footer__container {
    color: white;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;

    &__section {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        &__title {
            text-transform: uppercase;
            font-weight: bolder;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                font-size: 30px;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        &__list-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            list-style: none;
            gap: 1rem;
            padding: 0;

            &__item {
                a {
                    list-style: none;
                    color: white;
                    font-size: 14px;
                }
            }
        }
    }
}

.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}

@include media-breakpoint-up(md) {
    .pre-footer__container {
        flex-direction: row;
        gap: 1rem;
        justify-content: space-around;

        &__section {
            &__title {
                span {
                    display: none;
                }
            }
        }
    }
}
</style>